function clickLeft() {
    let projectsContainer = document.querySelector('#gb-installs-showcase-row');
    projectsContainer.scrollTo({
        left: projectsContainer.scrollLeft - 270,
        top: 0,
        behavior: "smooth"
    });
}

function clickRight() {
    let projectsContainer = document.querySelector('#gb-installs-showcase-row');
    projectsContainer.scrollTo({
        left: projectsContainer.scrollLeft + 270,
        top: 0,
        behavior: "smooth"
    });
}

function setFocusPosition(projectno) {
    let projectsContainer = document.querySelector('#gb-installs-showcase-row');
    projectsContainer.scrollTo({
        left: projectno * 270,
        top: 0,
        behavior: "smooth"
    });
}


